// campaign list
export const FETCHING_CAMPAIGNS_LIST = '@@toyota/FETCHING_CAMPAIGNS_LIST';
export const FETCHED_CAMPAIGNS_LIST = '@@toyota/FETCHED_CAMPAIGNS_LIST';
export const FETCHED_CAMPAIGNS_LIST_FAILED = '@@toyota/FETCHED_CAMPAIGNS_LIST_FAILED';

export const CLEAR_CAMPAIGNS_LIST = '@@toyota/CLEAR_CAMPAIGNS_LIST';

// campaign
export const FETCHING_CAMPAIGN_BY_ID = '@@toyota/FETCHING_CAMPAIGN_BY_ID';
export const FETCHED_CAMPAIGN_BY_ID = '@@toyota/FETCHED_CAMPAIGN_BY_ID';
export const FETCHED_CAMPAIGN_BY_ID_FAILED = '@@toyota/FETCHED_CAMPAIGN_BY_ID_FAILED';

export const CLEAR_CAMPAIGN = '@@toyota/CLEAR_CAMPAIGN';

export const ADDING_CAMPAIGN = '@@toyota/ADDING_CAMPAIGN';
export const ADDED_CAMPAIGN = '@@toyota/ADDED_CAMPAIGN';
export const ADDED_CAMPAIGN_FAILED = '@@toyota/ADDED_CAMPAIGN_FAILED';

export const UPDATING_CAMPAIGN = '@@toyota/UPDATING_CAMPAIGN';
export const UPDATED_CAMPAIGN = '@@toyota/UPDATED_CAMPAIGN';
export const UPDATED_CAMPAIGN_FAILED = '@@toyota/UPDATED_CAMPAIGN_FAILED';

export const SENDING_CAMPAIGN_NOTIFICATION = '@@toyota/SENDING_CAMPAIGN_NOTIFICATION';
export const SENDED_CAMPAIGN_NOTIFICATION = '@@toyota/SENDED_CAMPAIGN_NOTIFICATION';
export const SENDED_CAMPAIGN_NOTIFICATION_FAILED = '@@toyota/SENDED_CAMPAIGN_NOTIFICATION_FAILED';

export const FETCHING_CAMPAIGN_ATTACHMENTS = '@@toyota/FETCHING_CAMPAIGN_ATTACHMENTS';
export const FETCHED_CAMPAIGN_ATTACHMENTS = '@@toyota/FETCHED_CAMPAIGN_ATTACHMENTS';
export const FETCHED_CAMPAIGN_ATTACHMENTS_FAILED = '@@toyota/FETCHED_CAMPAIGN_ATTACHMENTS_FAILED';

export const SAVING_CAMPAIGN_ATTACHMENTS = '@@toyota/SAVING_CAMPAIGN_ATTACHMENTS';
export const SAVED_CAMPAIGN_ATTACHMENTS = '@@toyota/SAVED_CAMPAIGN_ATTACHMENTS';
export const SAVED_CAMPAIGN_ATTACHMENTS_FAILED =
  '@@toyota/SAVED_CAMPAIGN_ATTACHMENTS_FAILED';

export const SET_CAMPAIGN_FILES = '@@toyota/SET_CAMPAIGN_FILES';

// campaign chassis array
export const PROCESSING_CAMPAIGN_CHASSIS = '@@toyota/PROCESSING_CAMPAIGN_CHASSIS';
export const PROCESSED_CAMPAIGN_CHASSIS = '@@toyota/PROCESSED_CAMPAIGN_CHASSIS';
export const PROCESSED_CAMPAIGN_CHASSIS_FAILED = '@@toyota/PROCESSED_CAMPAIGN_CHASSIS_FAILED';

export const REMOVING_ELEMENT_FOR_CAMPAIGN_CHASSIS = '@@toyota/REMOVING_ELEMENT_FOR_CAMPAIGN_CHASSIS';
export const REMOVED_ELEMENT_FOR_CAMPAIGN_CHASSIS =
  '@@toyota/REMOVED_ELEMENT_FOR_CAMPAIGN_CHASSIS';
export const REMOVED_ELEMENT_FOR_CAMPAIGN_CHASSIS_FAILED =
  '@@toyota/REMOVED_ELEMENT_FOR_CAMPAIGN_CHASSIS_FAILED';

export const DOWNLOAD_CAMPAIGN_CHASSIS_EXCEL_REQUEST =
  '@@toyota/DOWNLOAD_CAMPAIGN_CHASSIS_EXCEL_REQUEST';
export const DOWNLOAD_CAMPAIGN_CHASSIS_EXCEL_SUCCESS =
  '@@toyota/DOWNLOAD_CAMPAIGN_CHASSIS_EXCEL_SUCCESS';
export const DOWNLOAD_CAMPAIGN_CHASSIS_EXCEL_FAILED =
  '@@toyota/DOWNLOAD_CAMPAIGN_CHASSIS_EXCEL_FAILED';

export const CLEAR_CHASSIS_EXCEL_FILE = '@@toyota/CLEAR_CHASSIS_EXCEL_FILE';

// campaign parts array
export const FETCHING_PARTS_BY_CAMPAIGN = '@@toyota/FETCHING_PARTS_BY_CAMPAIGN';
export const FETCHED_PARTS_BY_CAMPAIGN = '@@toyota/FETCHED_PARTS_BY_CAMPAIGN';
export const FETCHED_PARTS_BY_CAMPAIGN_FAILED = '@@toyota/FETCHED_PARTS_BY_CAMPAIGN_FAILED';

export const FETCHING_CAMPAIGN_PART = '@@toyota/FETCHING_CAMPAIGN_PART';
export const FETCHED_CAMPAIGN_PART = '@@toyota/FETCHED_CAMPAIGN_PART';
export const FETCHED_CAMPAIGN_PART_FAILED = '@@toyota/FETCHED_CAMPAIGN_PART_FAILED';

export const REMOVING_ELEMENT_FOR_CAMPAIGN_PARTS = '@@toyota/REMOVING_ELEMENT_FOR_CAMPAIGN_PARTS';
export const REMOVED_ELEMENT_FOR_CAMPAIGN_PARTS = '@@toyota/REMOVED_ELEMENT_FOR_CAMPAIGN_PARTS';
export const REMOVED_ELEMENT_FOR_CAMPAIGN_PARTS_FAILED = '@@toyota/REMOVED_ELEMENT_FOR_CAMPAIGN_PARTS_FAILED';

export const ADDING_ELEMENT_FOR_CAMPAIGN_PARTS = '@@toyota/ADDING_ELEMENT_FOR_CAMPAIGN_PARTS';
export const ADDED_ELEMENT_FOR_CAMPAIGN_PARTS = '@@toyota/ADDED_ELEMENT_FOR_CAMPAIGN_PARTS';
export const ADDED_ELEMENT_FOR_CAMPAIGN_PARTS_FAILED = '@@toyota/ADDED_ELEMENT_FOR_CAMPAIGN_PARTS_FAILED';

export const CHANGE_PARTS_MIN_STOCK = '@@toyota/CHANGE_PARTS_MIN_STOCK';

// campaign tasks array
export const FETCHING_CAMPAIGN_TASK = '@@toyota/FETCHING_CAMPAIGN_TASK';
export const FETCHED_CAMPAIGN_TASK = '@@toyota/FETCHED_CAMPAIGN_TASK';
export const FETCHED_CAMPAIGN_TASK_FAILED = '@@toyota/FETCHED_CAMPAIGN_TASK_FAILED';

export const ADDING_ELEMENT_FOR_CAMPAIGN_TASKS = '@@toyota/ADDING_ELEMENT_FOR_CAMPAIGN_TASKS';
export const ADDED_ELEMENT_FOR_CAMPAIGN_TASKS = '@@toyota/ADDED_ELEMENT_FOR_CAMPAIGN_TASKS';
export const ADDED_ELEMENT_FOR_CAMPAIGN_TASKS_FAILED = '@@toyota/ADDED_ELEMENT_FOR_CAMPAIGN_TASKS_FAILED';

export const REMOVING_ELEMENT_FOR_CAMPAIGN_TASKS = '@@toyota/REMOVING_ELEMENT_FOR_CAMPAIGN_TASKS';
export const REMOVED_ELEMENT_FOR_CAMPAIGN_TASKS = '@@toyota/REMOVED_ELEMENT_FOR_CAMPAIGN_TASK';
export const REMOVED_ELEMENT_FOR_CAMPAIGN_TASKS_FAILED = '@@toyota/REMOVED_ELEMENT_FOR_CAMPAIGN_TASKS_FAILED';

// campaign chassis list
export const FETCHING_CAMPAIGN_CHASSIS_LIST = '@@toyota/FETCHING_CAMPAIGN_CHASSIS_LIST';
export const FETCHED_CAMPAIGN_CHASSIS_LIST = '@@toyota/FETCHED_CAMPAIGN_CHASSIS_LIST';
export const FETCHED_CAMPAIGN_CHASSIS_LIST_FAILED =
  '@@toyota/FETCHED_CAMPAIGN_CHASSIS_LIST_FAILED';

export const FETCHING_CAMPAIGN_LIST_BY_CHASSIS = '@@toyota/FETCHING_CAMPAIGN_LIST_BY_CHASSIS';
export const FETCHED_CAMPAIGN_LIST_BY_CHASSIS = '@@toyota/FETCHED_CAMPAIGN_LIST_BY_CHASSIS';
export const FETCHED_CAMPAIGN_LIST_BY_CHASSIS_FAILED =
  '@@toyota/FETCHED_CAMPAIGN_LIST_BY_CHASSIS_FAILED';

export const CLEAR_CAMPAIGN_CHASSIS_LIST = '@@toyota/CLEAR_CAMPAIGN_CHASSIS_LIST';
export const CLEAR_CAMPAIGN_LIST_BY_CHASSIS = '@@toyota/CLEAR_CAMPAIGN_LIST_BY_CHASSIS';

// warranty campaigns

export const FETCHING_WARRANTY_CAMPAIGNS = '@@toyota/FETCHING_WARRANTY_CAMPAIGNS';
export const FETCHED_WARRANTY_CAMPAIGNS = '@@toyota/FETCHED_WARRANTY_CAMPAIGNS';
export const FETCHED_WARRANTY_CAMPAIGNS_FAILED =
  '@@toyota/FETCHED_WARRANTY_CAMPAIGNS_FAILED';

export const DOWNLOAD_WARRANTY_CAMPAIGNS_EXCEL_REQUEST = '@@toyota/DOWNLOAD_WARRANTY_CAMPAIGNS_EXCEL_REQUEST';
export const DOWNLOAD_WARRANTY_CAMPAIGNS_EXCEL_SUCCESS = '@@toyota/DOWNLOAD_WARRANTY_CAMPAIGNS_EXCEL_SUCCESS';
export const DOWNLOAD_WARRANTY_CAMPAIGNS_EXCEL_FAILED = '@@toyota/DOWNLOAD_WARRANTY_CAMPAIGNS_EXCEL_FAILED';

export const CLEAR_WARRANTY_CAMPAIGNS = '@@toyota/CLEAR_WARRANTY_CAMPAIGNS';
export const CLEAR_WARRANTY_CAMPAIGNS_EXCEL_FILE = '@@toyota/CLEAR_WARRANTY_CAMPAIGNS_EXCEL_FILE';
